<template>
<v-icon>  {{icon}}  </v-icon>
</template>

<script>
import {mapGetters} from "vuex";
import useUnitText from "@/wl-unit-text/useUnitText";

export default {
  name: "WnlUnitIcon",
  computed: {
    ...mapGetters(['userDetails']),
    icon(){
      return this.replaceIcon(this.userDetails.UnitType)
    },
  },
  methods:{
    replaceIcon(type){
      return useUnitText().replaceIcon(type)
    }
  }
}
</script>

<style scoped>

</style>